export const getServer = () =>
  'https://api-rest-service-cidoa-production.up.railway.app';
